/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventTracker = exports.EventTracker = function EventTracker() {
	  _classCallCheck(this, EventTracker);
	
	  this.pageView = function (data) {
	    data = data || {};
	    var oReq = new XMLHttpRequest();
	    oReq.open("POST", "/siteapi/logs/pageview");
	    oReq.overrideMimeType("application/json");
	    data.referrer = document.referrer;
	    data.origin_full_url = window.location;
	    data.origin_path = window.location.pathname;
	    oReq.send(JSON.stringify(data));
	  };
	
	  this.trackEvent = function (data) {
	    data = data || {};
	    var oReq = new XMLHttpRequest();
	    oReq.open("POST", "/siteapi/logs/event");
	    oReq.overrideMimeType("application/json");
	    data.referrer = document.referrer;
	    data.origin_full_url = window.location;
	    data.origin_path = window.location.pathname;
	    oReq.send(JSON.stringify(data));
	  };
	};
	
	global.EventTracker = EventTracker;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// events.js